import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0daba776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booking-page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "card-wrapper mb-8 pb-5" }
const _hoisted_5 = { class: "card-header-wrapper" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = { class: "title-3 m-auto" }
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = { class: "title-3" }
const _hoisted_12 = { class: "title-3" }
const _hoisted_13 = { class: "title-3" }
const _hoisted_14 = { class: "title-3 header-name" }
const _hoisted_15 = { class: "title-3 header-name" }
const _hoisted_16 = { class: "flex justify-content-end" }
const _hoisted_17 = { class: "controller-wrapper" }

import axios from "axios";
/**
 * Vueの基本機能
 * コンポーネントのライフサイクルとリアクティブな状態管理に使用
 */
import { onMounted, ref, computed } from "vue";
/**
 * Vuexストア
 * アプリケーション全体の状態管理に使用
 */
import { useStore } from "vuex";
/**
 * Vue Router
 * ルーティング情報の取得に使用
 */
import { useRoute } from "vue-router";
/**
 * ルーティングユーティリティ
 * 画面遷移の制御に使用
 */
import RouterUtils from "@/common/utils/router.util";
/**
 * 数値フォーマットユーティリティ
 * 金額表示のフォーマットに使用
 */
import NumberUtils from "@/clinic/utils/number-utils";
/**
 * ルーティング定数
 * 画面遷移先の定義に使用
 */
import RouterConstants from "@/customer/constants/router.constants";
/**
 * APIルーティング定数
 * APIエンドポイントの定義に使用
 */
import ApiRouterConstants from "@/common/constants/api.router.constants";
/**
 * 予約設定サービス
 * 予約設定の取得に使用
 */
import { BookingSettingService } from "@/customer/services";
/**
 * スタッフの型定義
 * スタッフ情報の型チェックに使用
 */
import { IStaff } from "@/clinic/typings/entities/staff";
/**
 * クリニックパートナーの列挙型
 * パートナー種別の判定に使用
 */
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * スタッフ一覧
 * 選択可能なスタッフのリスト
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'Booking',
  setup(__props) {

/**
 * スタッフ選択画面コンポーネント
 * 指名予約モードの場合、スタッフ一覧を表示し選択を促す画面
 * 指名なし予約の場合は自動的にデフォルトスタッフを設定
 */

/**
 * HTTPクライアント
 * APIリクエストに使用
 */
const staffList = ref<IStaff[]>([]);
/**
 * デフォルトスタッフ
 * 指名なし予約時に使用するスタッフ
 */
const defaultStaff = ref<IStaff | null>(null);
/**
 * 予約設定
 * クリニックの予約に関する設定情報
 */
const bookingSetting = ref<Record<string, any>>({});
/**
 * Vuexストアインスタンス
 */
const store = useStore();
/**
 * ルート情報
 * 画面遷移元の判定に使用
 */
const route = useRoute();

/**
 * 指名予約かどうかを判定する算出プロパティ
 * @type {ComputedRef<boolean>}
 */
const isNominate = computed(() => bookingSetting.value.option === "nominate");

/**
 * スタッフ選択時の処理
 * 選択したスタッフの情報をストアに保存し、プレビュー画面に遷移する
 * @param {IStaff} staff - 選択されたスタッフ
 */
const handleSelectStaff = (staff: IStaff) => {
  // 選択したスタッフの情報をストアに保存
  store.commit("booking/selectStaff", staff);
  // 指名料を設定
  store.commit("booking/setStaffOrderPrice", staff.order_price);
  // 選択したスタッフIDを設定
  store.commit("booking/setSelectedStaffId", staff.id);
  // 自動スタッフ配分を無効化
  store.commit("bookingSetting/setAutoStaffDistribution", false);
  // デフォルトスタッフ使用フラグを無効化
  store.commit("booking/setUseDefaultStaff", false);
  // プレビュー画面に遷移
  RouterUtils.goTo(RouterConstants.BOOKING_PREVIEW_ROUTER_NAME);
};

/**
 * 指名なしで予約を進める処理
 * デフォルトスタッフを設定し、自動スタッフ配分を有効化する
 * @returns {Promise<void>}
 */
const bookingWithoutStaff = async () => {
  if (!defaultStaff.value) return;
  // デフォルトスタッフの情報をストアに保存
  store.commit("booking/selectStaff", defaultStaff.value);
  // 指名料を設定
  store.commit("booking/setStaffOrderPrice", defaultStaff.value.order_price);
  // デフォルトスタッフ使用フラグを有効化
  store.commit("booking/setUseDefaultStaff", true);
  // デフォルトスタッフIDを設定
  store.commit("booking/setSelectedStaffId", defaultStaff.value.id);
  // 自動スタッフ配分データを設定
  store.commit("booking/setAutoStaffDistributionData", [defaultStaff.value.id]);
  // 予約設定を取得して自動スタッフ配分の設定を更新
  const { data: settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  if (settings?.value) {
    store.commit("bookingSetting/setBookingSetting", settings.value);
    bookingSetting.value = settings.value;
  }

  // プレビュー画面に遷移
  RouterUtils.goTo(RouterConstants.BOOKING_PREVIEW_ROUTER_NAME);
};

/**
 * スタッフの指名料を表示用にフォーマット
 * @param {IStaff} staff - スタッフ情報
 * @returns {string} フォーマットされた指名料
 */
const orderPrice = (staff: IStaff) => {
  if (staff.order_price) {
    return NumberUtils.formatJPCurrency(staff.order_price) + " (指名料)";
  }
  return "";
};

/**
 * ローディング状態
 * @type {Ref<boolean>}
 */
const isLoading = ref(true);

/**
 * メニューオプション有無
 * @type {Ref<boolean>}
 */
const hasMenuOption = ref(false);

/**
 * コンポーネントのマウント時の処理
 * 予約設定の取得、スタッフ一覧の取得、デフォルトスタッフの設定、指名なし予約の自動設定、メニューオプションの取得を行う
 */
onMounted(async () => {
  const selectedMenu = store.getters["booking/selectedMenu"];

  // 予約設定の取得と保存を先に行う
  const { data: settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  // ストアとローカル変数に保存
  store.commit("bookingSetting/setBookingSetting", settings.value);
  bookingSetting.value = settings.value;

  // スタッフ一覧を取得
  const res = await axios.get(ApiRouterConstants.API_STAFF, {
    params: { clinic_id: store.getters["line_account/clinicId"] },
    headers: { Accept: "application/json" },
  });
  // 選択中のメニューIDに紐づくスタッフのみをフィルタリング
  staffList.value = res.data.filter((staff: IStaff) => staff.medical_menu_ids.includes(selectedMenu.id));
  // デフォルトスタッフの設定（優先順位：1.選択メニューに紐づくスタッフ 2.全スタッフ）
  defaultStaff.value =
    staffList.value.find((staff: IStaff) => staff.default_staff) ||
    res.data.find((staff: IStaff) => staff.default_staff) ||
    null;

  // 指名なし予約の場合、またはRipicleパートナーで選択メニューにスタッフ紐付きが0の場合に自動的にデフォルトスタッフを設定
  if (
    bookingSetting.value.option !== "nominate" ||
    (bookingSetting.value.partner === ClinicPartner.Ripicle && staffList.value.length === 0)
  ) {
    bookingWithoutStaff();
  }

  // メニューオプション情報を取得
  const resOption = await axios.get(ApiRouterConstants.API_MENU_OPTION, {
    params: {
      clinic_id: store.getters["line_account/clinicId"],
      menu_id: store.getters["booking/selectedMenu"].id,
    },
    headers: { Accept: "application/json" },
  });
  // オプションが1件以上あればtrue
  hasMenuOption.value = Array.isArray(resOption.data) ? resOption.data.length > 0 : !!resOption.data;

  isLoading.value = false;
});

/**
 * 戻るボタンクリック時の処理
 * 前の画面に遷移する
 * 遷移先は以下の条件で決定される：
 * 1. オプションがないメニュー、またはメニュー画面から来た場合はメニュー選択画面に戻る
 * 2. それ以外はオプション選択画面に戻る
 */
const back = () => {
  if (!hasMenuOption.value || route.query.from === "menu") {
    RouterUtils.goTo(RouterConstants.BOOKING_MENU_ROUTER_NAME);
  } else {
    RouterUtils.goTo(RouterConstants.BOOKING_OPTION_ROUTER_NAME);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(isNominate))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffList.value, (staff) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      key: staff.id,
                      class: _normalizeClass({ 'p-card-selected': staff.id == _unref(store).getters['booking/selectedStaffId'] })
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            (staff.avatar?.url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "icon",
                                  src: staff.avatar?.url,
                                  alt: ""
                                }, null, 8, _hoisted_7))
                              : (_openBlock(), _createBlock(_component_Avatar, {
                                  key: 1,
                                  icon: "pi pi-user",
                                  shape: "circle"
                                })),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("p", _hoisted_9, [
                                _createTextVNode(_toDisplayString(staff.name_kanji), 1),
                                _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(staff.name_kana) + ")", 1)
                              ]),
                              _createElementVNode("p", _hoisted_11, _toDisplayString(staff.position), 1),
                              _createElementVNode("p", _hoisted_12, _toDisplayString(staff.special_treatments), 1),
                              _createElementVNode("p", _hoisted_13, _toDisplayString(orderPrice(staff)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(staff.treatment_history), 1),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(staff.comments), 1)
                      ]),
                      footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_Button, {
                            label: "選択",
                            onClick: ($event: any) => (handleSelectStaff(staff))
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Button, {
              class: "btn cancel-btn w-full",
              onClick: back
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            }),
            (bookingSetting.value.show_button_without_staff)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "btn accept-btn w-full",
                  onClick: bookingWithoutStaff
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("指名しないで進む")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})